<app-header
  text="Standardfarben"
  icon="fas fa-star"
  sub="Gelten für neue Karten und Diagramme, sofern Indikator oder Datensatz kein eigenes Farbset vorgeben." />
<div class="p-card surface-ground p-3 mb-4">
  <form [formGroup]="form" class="grid p-fluid">
    @for (slot of slots; track slot.key) {
      <div class="col-12">
        @if (readonly) {
          <div class="flex align-items-center gap-2 mb-2">
            <i [class]="slot.icon"></i> {{ slot.label }}
          </div>
          @if (colorsetOf(slot.key); as colorset) {
            <div class="flex align-items-center gap-2">
              <span>{{ colorset.name }}</span>
              <app-colors [colorset]="colorset" />
            </div>
          } @else {
            @if (fallbackOf(slot.key); as fallback) {
              <div
                class="flex align-items-center gap-2 text-color-secondary font-italic">
                <span
                  >{{ fallback.colorset.name }} ({{ fallback.source }})</span
                >
                <app-colors [colorset]="fallback.colorset" class="opacity-60" />
              </div>
            }
          }
        } @else {
          <app-colorset-dropdown
            [label]="slot.label"
            [name]="'default-' + slot.key"
            [fallback]="fallbackOf(slot.key)"
            [formControlName]="slot.key" />
        }
      </div>
    }
  </form>
</div>
